import type { ComponentProps } from 'react';
import { MasonryTextActionRenderer } from '@leagueplatform/masonry-renderers';

/**
 * Genesis `TextAction` underlines on `:hover` only, which never fires on touch.
 */
export const MasonryUnderlinedTextActionRenderer = ({
  css,
  ...props
}: ComponentProps<typeof MasonryTextActionRenderer>) => (
  <MasonryTextActionRenderer
    {...props}
    css={{ textDecoration: 'underline', ...css }}
  />
);
